import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-adminactivation-view',
  templateUrl: './adminactivation-view.component.html',
  styleUrls: ['./adminactivation.component.css']
})
export class AdminactivationViewComponent implements OnInit {

  ViewCustomer: any = [];
  actionHistory: any = [];
  listservices: any = [];
  liststb: any = [];
  liststbcust: any = [];
  listfactoryreset: any = [];
  alert_act='';

  alert_failed = false
  alert_success = false

  formReset = this.fb.group({
    email: [''],
    note: [''],
  })

  constructor(
	  private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJsOrder: LoadJsService,
	  private router: Router,
	  public partnerService: ApiPartnerService
  ) { }

  ngOnInit() {
  	this.loadStart();

  }

  loadStart() {
    let id = this.route.snapshot.paramMap.get('id');
  	//alert(id);
    this.loadCustomer(id)
    this.loadDetailreset(id)
  }

  loadCustomer(id: any) {
    return this.partnerService.GetViewCustomer(id).subscribe((output: any) => {
    //console.log(output);
       this.ViewCustomer = output.data;
       this.listservices = output.data.services;
       this.liststb = output.data.stb;
       this.liststbcust = output.data.stbcust;
       this.actionHistory = output.data.actionHistory;
    })
  }

  loadDetailreset(id: any) {
    return this.partnerService.GetListcustfactoryreset(id).subscribe((output: any) => {
    console.log(output);
       this.listfactoryreset = output.data;
    })
  }

  onActionClick(act:any, item: any)
  {
    this.alert_act = act;
    console.log(act);
    this.formReset.reset()

    // if ( act == "setkondisi" || act == "approve") {
    //   this.formApprove.reset()
    //   this.itemstb = item
    // }
  }

  submitreset(item:any, el: HTMLElement) {
    this.partnerService.PostCustfactoryreset(item.id, this.formReset.value)
      .subscribe((output: any) => {
        console.log(output)
        if ( output.status ){
          this.loadStart()
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
  
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
          setTimeout(()=>{
            this.alert_success = false
          }, 6000);
          
        } else {
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
        }
      }
    )
  }

}

